window.ALLOY_THIRD_PARTY_SCRIPTS = {};

function addScript(script, onload) {
  var scriptElement = document.createElement('script');
  Object.assign(scriptElement, script);
  scriptElement.type = 'text/javascript';
  if (onload) scriptElement.onload = onload;
  var s = document.getElementsByTagName('script')[0];

  if (s) {
    s.parentNode.insertBefore(scriptElement, s);
  }
}

function addScripts(scripts, onLastLoad) {
  var onload = scripts.slice(1).length ? addScripts.bind(null, scripts.slice(1), onLastLoad) : onLastLoad;
  addScript(scripts[0], onload);
}

export default function loadScripts(flag, scripts, callback) {
  if (window.ALLOY_THIRD_PARTY_SCRIPTS[flag]) return;
  window.ALLOY_THIRD_PARTY_SCRIPTS[flag] = true;
  addScripts(scripts, callback);
}
//# sourceMappingURL=loadScripts.js.map